import {
    ComponentObject,
    ComponentSelector,
    ComponentSelectors,
    ComponentElements,
    ComponentService,
    ComponentInjector,
    UIComponent

} from '@atypon/ui-utils';

class Texts extends ComponentObject {
    isOpen = null;
}

class ClassList extends ComponentObject {
    dataOpened = 'popover-open';
    close = '.popover-close';
    toggle = '.popover-toggle';
    container = '.popover';
    description = ".popover-desc"
}

class Selectors extends ComponentSelectors {
    container = new ComponentSelector('.popover', 'document');
    trigger = new ComponentSelector('.popover-toggle', 'document');
}

class Elements extends ComponentElements<Selectors> {
    container: HTMLElement[] = [];
    trigger: HTMLButtonElement[] = [];

}
interface Popover extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)

class Popover implements UIComponent {

    constructor(readonly wrapper: HTMLElement) { }

    initialize(): void {
        this.elements.initialize(this.wrapper);
        this.addEventListeners();
    }

    addEventListeners(): void {

        this.elements.container.forEach((container: HTMLElement) => {
            const close = container.querySelector(this.classList.close);
            const trigger = container.querySelector(this.classList.toggle);

            trigger?.addEventListener('click', this.handleTriggerClick.bind(this, trigger));
            close?.addEventListener('click', this.handleCloseClick.bind(this, close));
        })

        document.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            const isPopover = target.closest(this.classList.container);
            if (!isPopover) {
                this.closeAllPopovers();
            }
        });
    }

    handleTriggerClick(trigger: Element, e: Event): void {
        e.preventDefault();
        e.stopPropagation();
        this.texts.isOpen = trigger.classList.contains(this.classList.dataOpened);
        this.closeAllPopovers();
        if (!this.texts.isOpen) {
            this.openPopover(trigger);
        }
    }

    handleCloseClick(close: Element, e: Event): void {
        e.preventDefault();
        e.stopPropagation();
        const trigger: HTMLButtonElement = close.closest(this.classList.container)?.querySelector(this.classList.toggle);

        if (trigger) {
            this.closePopover(trigger);
        }
    }

    openPopover(element: any): void {
        element.setAttribute('aria-expanded', 'true');
        element.classList.add(this.classList.dataOpened);
        const content = element.closest(this.classList.container).querySelector(this.classList.description);
        
        content?.focus();
    }

    closePopover(element: HTMLButtonElement): void {
        element.setAttribute('aria-expanded', 'false');
        element.classList.remove(this.classList.dataOpened);
    }

    closeAllPopovers(): void {
        this.elements.trigger.forEach((button: HTMLButtonElement) => {
            this.closePopover(button);
        })
    }
}

export default Popover;